import React from "react";
import { connect } from "react-redux";
import { 
  Users,
  MapPin,
  Award,
  Globe,
} from "lucide-react";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import LocationsWrapper from "./components/LocationWrapper";

const CountryGuides = () => {

  return (
    <div className="space-y-6">
        <SummaryHeader
            title={"Country Guide"}
            icon={Globe}
            description={"Comprehensive insights into our sourcing locations"}
            color={"bg-indigo"}
        >
            <div className="summary-item-container">
                <SummaryItem
                    title="Countries"
                    icon={<MapPin />}
                    display="3 Locations"
                />
                <SummaryItem
                    title="Total Talent Pool"
                    icon={<Users />}
                    display="1.5B+ People"
                />
                <SummaryItem
                    title="Expertise Areas"
                    icon={<Award />}
                    display="All Industries"
                />
            </div>
        </SummaryHeader>
        <LocationsWrapper/>
    </div>
  );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(CountryGuides);